export default {
  FORMULA_PERCENTAGE_PLACEHOLDER:
    'Start by inserting a %value% or a function (%min%, %max%, %round%, %round up%, %round down%).',
};
